import {Modal} from 'react-bootstrap'
import React, {FC} from 'react'
import ComponentButton from '../../../constructor/components/ComponentButton'
import {useIntl} from 'react-intl'

type TProfileCompleteModal = {
    show: boolean
    setShow: () => void
}

const ProfileCompleteModal: FC<TProfileCompleteModal> = ({show, setShow}) => {
    const intl = useIntl()

    return (
        <Modal show={show} backdrop='static' keyboard={false} centered>
            <Modal.Header>
                <Modal.Title>
                    {intl.formatMessage({id: 'MODULE_PROFILE_MODAL.COMPLETE_TITLE'})}
                </Modal.Title>
            </Modal.Header>

            <Modal.Body>
                {intl.formatMessage({id: 'MODULE_PROFILE_MODAL.COMPLETE_TEXT'})}
            </Modal.Body>

            <Modal.Footer>
                <ComponentButton
                    className=''
                    type='custom'
                    settings={{
                        title: intl.formatMessage({id: 'BUTTON.NEXT'}),
                        background: 'dark',
                        icon: '',
                    }}
                    customHandler={setShow}
                />
            </Modal.Footer>
        </Modal>
    )
}

export default ProfileCompleteModal
